import React, { useRef, useState } from "react";
import List from "../UniversalComponents/ListComponent";
import withPortalHOC from "../UniversalComponents/WithPortalHOC";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { getHexWithOpacity, hexWithOpacity, safeJsonStringify } from "../../utils/utilityFunctions/stringUtility";

const PortalList = withPortalHOC(List);

const BasicSelect = ({
  showSearch,
  name,
  value,
  onClick = () => {},
  disabled,
  selectedOptions = [],
  options,
  dynamicOptions,
  label = "Option",
  apiCall,
  onChange,
  isLoading,
  size = "small",
  addButton,
  addButtonLabel,
  addButtonAction,
  isEditList = false,
  editListHandler = () => null,
  useFetchHook,
  handleCallHook,
  noKeyboardNavigation,
  displayValue,
  onSearch = null,
  isError = false,
  isButton = false,
  onEditColor = false,
  basicSelectClass = "",
  arrow,
  textBoldonHover = false,
  transformedTemplates,
  apiCallParam,
}) => {
  const [open, setIsOpen] = React.useState(false);
  const inputRef = useRef(null);
  const handleClickSelect = () => {
    setIsOpen(!open);
    if (apiCall && apiCallParam) {
      apiCall(apiCallParam);
    } else if (apiCall && !apiCallParam) {
      apiCall("");
    } else if (dynamicOptions) {
      onClick();
    } else if (handleCallHook) {
      handleCallHook();
    }
  };

  const handleSelectOption = (value) => {
    onChange(value);
    setIsOpen(false);
  };

  const errorStyleClass = "border-b-2 border-b-[#EF4444]";
  const activeStyleClass = "border-[#7A7D84]";
  const disabledStyleClass = "!border-[#DFE2E5] !bg-[#EDEDED] !text-[#868686] !cursor-not-allowed";

  const dynamicClassDefinition = () => {
    if (disabled) {
      return disabledStyleClass;
    } else if (open) {
      return activeStyleClass;
    } else if (isError && !open && !selectedOptions?.length) {
      return errorStyleClass;
    }
  };

  const [isHovering, setIsHovering] = useState(false);

  console.log(options, selectedOptions, "dynamicOptions jaja basic Select");
  return (
    <>
      <div
        onClick={() => {
          !disabled && handleClickSelect();
        }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        className={`rounded border border-DFE2E5 ${isButton ? "bg-[#123251] text-white" : onEditColor ? "bg-gray-200 text-[#292E33]" : " bg-white text-[#292E33]"}  text-[#292E33] cursor-pointer focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 ${basicSelectClass ? basicSelectClass : "w-full"} h-7 p-1 px-2 whitespace-nowrap overflow-hidden text-ellipsis flex items-center placeholder:font-poppins ${dynamicClassDefinition()}  `}
        style={{
          padding: size === "small" ? "0.3rem 0.4rem" : "1.02rem 0.714rem ",
          padding: size === "large" ? "1.15rem 0.714rem" : "1.02rem 0.714rem ",
          fontSize: size === "small" ? "0.8rem" : "0.9rem",
          backgroundColor:
            isHovering && textBoldonHover
              ? getHexWithOpacity(selectedOptions[0].statusColor, 30)
              : selectedOptions?.[0]?.statusColor
                ? getHexWithOpacity(selectedOptions[0].statusColor, 10)
                : "",
          color: selectedOptions?.[0]?.statusColor,
          fontWeight: isHovering && textBoldonHover ? "700" : selectedOptions?.[0]?.statusColor ? "500" : "400",
          // backgroundColor: selectedOptions?.[0]?.bgColor,
          // color: selectedOptions?.[0]?.textColor,
          // border: `1px solid ${selectedOptions?.[0]?.borderColor}`,
        }}
        ref={inputRef}
      >
        <p
          className={`flex-1 truncate ${selectedOptions?.[0]?.label || displayValue || value ? "text-[#292E33]" : isButton ? "text-white" : "text-[#AFAFAF]"} `}
          style={{
            color: selectedOptions?.[0]?.color_code ? selectedOptions?.[0]?.color_code : "",
          }}
        >
          {" "}
          {selectedOptions?.[0]?.label || displayValue || safeJsonStringify(value) || `Select ${label}`}{" "}
        </p>

        {selectedOptions?.[0]?.icon}
        <DownArrow
          fill={selectedOptions?.[0]?.statusColor ? getHexWithOpacity(selectedOptions[0].statusColor, 30) : `#7A7D84`}
          className={`${open ? "rotate-180 " : "rotate-0"} transition-all duration-300`}
          style={{ marginLeft: "0.5rem" }}
        />
      </div>
      {open && (
        <PortalList
          open={open}
          listOpen={open}
          onClose={() => setIsOpen(!open)}
          containerRef={inputRef}
          boxWidth
          options={options}
          selectedOptions={selectedOptions}
          onOptionClick={(item) => {
            handleSelectOption({ target: { ...item?.[0], name, valueObj: item?.[0] } });
          }}
          personList={false}
          showSearch={showSearch}
          disabled={disabled}
          name={name}
          size={size}
          borderRadius="4px"
          yAxis={0}
          // noChildren
          isLoading={isLoading}
          addButton={addButton}
          addButtonLabel={addButtonLabel}
          isEditList={isEditList}
          editListHandler={editListHandler}
          noKeyboardNavigation={noKeyboardNavigation}
          addButtonAction={() => {
            setIsOpen(false);
            addButtonAction();
          }}
          onSearch={onSearch}
        />
      )}
    </>
  );
};

export default BasicSelect;
